// extracted by mini-css-extract-plugin
module.exports = {"CludoArrangementsResults":"CludoArrangementsResults_CludoArrangementsResults__RpiiQ"};